<template>
  <div>
    <ui-spinner v-if="loading.view == true"></ui-spinner>
    <div v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Nombre *</label>
            <input
              v-model="nombre"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Teléfono</label>
            <input
              v-model="telefono"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Sede</label>
            <select v-model="idSede" class="form-control">
              <option
                v-for="item in containers.sedes"
                :key="item.idSede"
                :value="item.idSede"
              >
                {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="" class="form-label">Responsable</label>
            <select v-model="idResponsable" class="form-control">
              <option
                v-for="item in containers.responsables"
                :key="item.idPersona"
                :value="item.idPersona"
              >
                {{ item.nombre }}
              </option>
            </select>
          </div>
          <div>
            <div class="text-right">
              <button
                class="btn btn-sm btn-outline-success"
                :disabled="loading.crud"
                @click="onNuevo"
              >
                Nuevo
              </button>
              <button
                class="ml-2 btn btn-sm btn-primary"
                :disabled="loading.crud"
                @click="onSave"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
                <tr class="text-center align-middle">
                  <th style="width: 80px"></th>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Sede</th>
                  <th>Responsable</th>
                  <th>UC</th>
                  <th>UM</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in containers.areas"
                  :key="item.idArea"
                  class="align-middle text-center"
                >
                  <td>
                    <button
                      class="btn btn-xs btn-icon btn-light-warning"
                      @click="onEditar(item)"
                    >
                      <span class="fa fa-fw fa-pencil-alt"></span>
                    </button>
                    <button
                      class="btn btn-xs btn-icon btn-light-danger ml-2"
                      @click="onEliminar(item)"
                    >
                      <span class="fa fa-fw fa-trash-alt"></span>
                    </button>
                  </td>
                  <td>{{ item.nombre }}</td>
                  <td>{{ item.telefono }}</td>
                  <td>{{ item.sede }}</td>
                  <td>{{ item.responsable }}</td>
                  <td>{{ item.usuarioCreador }}</td>
                  <td>{{ item.usuarioModif }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  layout: "app",
  data() {
    return {
      nombre: "",
      telefono: "",
      idSede: "",
      idResponsable: "",
      loading: {
        view: true,
        crud: false,
      },
      containers: {
        responsables: [],
        sedes: [],
        areas: [],
        idArea: null,
      },
    };
  },
  async created() {
    const vm = this;

    let {
      data: { content },
    } = await vm.axios.get("/mantenimiento/areas");

    vm.containers.sedes = content.sedes;
    vm.containers.responsables = content.personasOficina;
    vm.containers.areas = content.areas;

    vm.loading.view = false;
  },
  methods: {
    onSave() {
      let vm = this;
      let fd = {
        nombre: String(vm.nombre).trim(),
        telefono: String(vm.telefono).trim(),
        idSede: vm.idSede,
        idResponsable: vm.idResponsable,
        _method: "POST",
      };

      if (!fd.nombre) {
        return vm.$swal.fire(
          "",
          "Completa los campos obligatorios (*)",
          "warning"
        );
      }

      vm.loading.crud = true;

      let endpoint = "/mantenimiento/areas";

      if (vm.containers.idArea) {
        endpoint = `/mantenimiento/areas/${vm.containers.idArea}`;
        fd._method = "PUT";
      }

      vm.axios
        .post(endpoint, fd)
        .then((response) => {
          if (vm.containers.idArea) {
            let findArea = vm.containers.areas.find(
              (item) => item.idArea == vm.containers.idArea
            );

            findArea.nombre = fd.nombre;
            findArea.telefono = fd.telefono;
            findArea.idResponsable = fd.idResponsable;
            findArea.idSede = fd.idSede;
            findArea.responsable =
              vm.containers.responsables.find(
                (item) => item.idPersona == fd.idResponsable
              )?.nombre || null;

            findArea.sede =
              vm.containers.sedes.find((item) => item.idSede == fd.idSede)
                ?.nombre || null;
            findArea.usuarioModif = vm.$store.state.user.codigo;

          } else {
            vm.containers.areas.push({
              ...fd,
              idArea: response.data.content.id,
              responsable:
                vm.containers.responsables.find(
                  (item) => item.idPersona == fd.idResponsable
                )?.nombre || null,
              sede:
                vm.containers.sedes.find((item) => item.idSede == fd.idSede)
                  ?.nombre || null,
              usuarioCreador: vm.$store.state.user.codigo,
            });

            vm.containers.idArea = response.data.content.id;
          }

          vm.$toast.fire(response.data.message, "", "success");
        })
        .catch((error) => {
          vm.$toast.fire(error.response.data.message, "", "error");
        })
        .finally(() => {
          vm.loading.crud = false;
        });
    },
    onEditar(pItem) {
      let vm = this;
      vm.containers.idArea = pItem.idArea;
      vm.idSede = pItem.idSede;
      vm.nombre = pItem.nombre;
      vm.telefono = pItem.telefono || "";
      vm.idResponsable = pItem.idResponsable;
    },
    async onEliminar(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
        "",
        "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
          .delete(`/mantenimiento/areas/${pItem.idArea}`)
          .then((response) => {
            let tempRegistros = [...vm.containers.areas];
            vm.containers.areas = tempRegistros.filter(
              (item) => item.idArea != pItem.idArea
            );
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    onNuevo() {
      let vm = this;
      vm.containers.idArea = null;
      vm.nombre = "";
      vm.telefono = "";
      vm.idSede = "";
      vm.idResponsable = "";
    },
  },
};
</script>
